import { render, staticRenderFns } from "./ScrollSpyText.vue?vue&type=template&id=33cc886f&scoped=true&"
import script from "./ScrollSpyText.vue?vue&type=script&lang=js&"
export * from "./ScrollSpyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc886f",
  null
  
)

export default component.exports